import React from 'react';

interface BookingConfirmationProps {
  vehicle: any;
  bookingDetails: {
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    totalPrice: number;
    totalHours: number;
  };
  onClose: () => void;
}

const BookingConfirmation: React.FC<BookingConfirmationProps> = ({
  vehicle,
  bookingDetails,
  onClose
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl border border-gray-200 shadow-xl max-w-md w-full mx-4 p-6">
        {/* Animation de succès */}
        <div className="text-center mb-6">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Réservation confirmée !</h2>
          <p className="text-gray-600">Votre réservation a été créée avec succès</p>
        </div>

        {/* Détails de la réservation */}
        <div className="space-y-4 mb-6">
          <div className="bg-gray-50 rounded-xl p-4">
            <h3 className="font-semibold text-gray-900 mb-3">Détails du véhicule</h3>
            <div className="flex items-center space-x-3 mb-3">
              <div className="text-2xl">{vehicle.icon || '🚗'}</div>
              <div>
                <div className="font-medium text-gray-900">{vehicle.title}</div>
                <div className="text-sm text-gray-600">Type: {vehicle.type}</div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-xl p-4">
            <h3 className="font-semibold text-gray-900 mb-3">Détails de la réservation</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Début:</span>
                <span className="font-medium">
                  {new Date(bookingDetails.startDate).toLocaleDateString('fr-FR')} à {bookingDetails.startTime}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Fin:</span>
                <span className="font-medium">
                  {new Date(bookingDetails.endDate).toLocaleDateString('fr-FR')} à {bookingDetails.endTime}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Durée:</span>
                <span className="font-medium">{bookingDetails.totalHours} heure(s)</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Prix total:</span>
                <span className="font-semibold text-indigo-600">{bookingDetails.totalPrice.toFixed(2)}€</span>
              </div>
            </div>
          </div>
        </div>

        {/* Informations supplémentaires */}
        <div className="bg-blue-50 rounded-xl p-4 mb-6">
          <div className="flex items-start space-x-3">
            <svg className="w-5 h-5 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <div className="text-sm text-blue-800">
              <p className="font-medium mb-1">Prochaines étapes :</p>
              <ul className="space-y-1 text-xs">
                <li>• Vous recevrez une confirmation par email</li>
                <li>• Rendez-vous au point de prise en charge à l'heure indiquée</li>
                <li>• Présentez votre pièce d'identité</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 py-2 px-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors"
          >
            Retour à la carte
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation; 